import React from 'react'
import SVG, { Props as InlineSvgProps } from 'react-inlinesvg'
import { toAbsoluteUrl } from '../AssetHelpers'
import { IconSize } from '..'

// react-inlinesvg 4 declara retorno ReactNode, que o TS 4.6 não aceita como elemento JSX.
export const InlineSvg = SVG as unknown as React.FC<InlineSvgProps>

type Props = {
  className?: string
  path: string
  svgClassName?: string
  color?: string
  size?: IconSize
  // Ícone decorativo ao lado de um texto: some do leitor de tela
  ariaHidden?: boolean
}

const KTSVG: React.FC<Props> = ({
  className = '',
  path,
  svgClassName = 'mh-50px',
  color,
  size = IconSize.ExtraSmall,
  ariaHidden,
}) => {
  return (
    <span className={`svg-icon ${size} ${className}`} aria-hidden={ariaHidden || undefined}>
      <InlineSvg src={toAbsoluteUrl(path)} className={svgClassName} color={color} />
    </span>
  )
}

export { KTSVG }
